import { ENCRYPT_SECERET_KEY } from '../redux/apiConstants';
import moment from 'moment-timezone';

const CryptoJS = require('crypto-js');

const viewerTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const dateFormatter2 = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  timeZone: viewerTimezone,
});

const dateFormatter4 = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
  timeZone: viewerTimezone,
});

export const getEventCalendarDateString = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    const part = trimmed.slice(0, 10);
    if (part.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(part)) return part;
    const tPart = trimmed.split('T')[0];
    if (tPart && tPart.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(tPart)) return tPart;
    return null;
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const atUtcMidnight =
      value.getUTCHours() === 0 &&
      value.getUTCMinutes() === 0 &&
      value.getUTCSeconds() === 0 &&
      value.getUTCMilliseconds() === 0;
    const y = atUtcMidnight ? value.getUTCFullYear() : value.getFullYear();
    const m = atUtcMidnight ? value.getUTCMonth() : value.getMonth();
    const d = atUtcMidnight ? value.getUTCDate() : value.getDate();
    const mm = String(m + 1).padStart(2, '0');
    const dd = String(d).padStart(2, '0');
    return `${y}-${mm}-${dd}`;
  }
  return null;
};

/**
 * Format event date for display as MM-DD-YYYY without timezone shift.
 * Use for event start/end dates so the selected calendar day is always shown.
 */
export const formatEventDateDisplay = (value) => {
  const ymd = getEventCalendarDateString(value);
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-').map(Number);
  const mm = String(m).padStart(2, '0');
  const dd = String(d).padStart(2, '0');
  return `${mm}-${dd}-${y}`;
};

const dateFormatter3 = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: viewerTimezone,
});

export const Encrypt = (value) => {
  const ciphertext = CryptoJS.AES.encrypt(value, ENCRYPT_SECERET_KEY).toString();
  // const encodedValue = encodeURIComponent(ciphertext);
  const encodedValue = ciphertext
    .replace(/\+/g, 'p1L2u3S')
    .replace(/\//g, 's1L2a3S4h')
    .replace(/=/g, 'e1Q2u3A4l');
  return encodedValue;
};

export const DecodeHtmlEntities = (html) => {
  if (!html) return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  return textarea.value;
};

// Plain-text location for table cells, so it renders as text rather than HTML.
// Handles the current { venue, street, city, country } shape and legacy HTML strings.
export const formatLocationText = (location) => {
  if (!location) return '';
  if (typeof location === 'string') {
    return DecodeHtmlEntities(location.replace(/<[^>]*>/g, ' '))
      .replace(/\s+/g, ' ')
      .trim();
  }
  return [location.venue, location.street, location.city, location.country]
    .filter(Boolean)
    .join(', ');
};

export const Decrypt = (value) => {
  // const decodeText = decodeURIComponent(value);
  const decodeText = value
    .replace(/p1L2u3S/g, '+')
    .replace(/s1L2a3S4h/g, '/')
    .replace(/e1Q2u3A4l/g, '=');
  const bytes = CryptoJS.AES.decrypt(decodeText, ENCRYPT_SECERET_KEY);
  const decodedValue = bytes.toString(CryptoJS.enc.Utf8);
  return decodedValue;
};

export const NumFormatter = (num) => {
  if (num > 999 && num < 1000000) {
    return `${(num / 1000).toFixed(2)}K`; // convert to K for number from > 1000 < 1 million
  }
  if (num > 1000000) {
    return `${(num / 1000000).toFixed(2)}M`; // convert to M for number from > 1 million
  }
  if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
  return num;
};
export const CapitalizeFirstLetter = (strs) => strs.charAt(0).toUpperCase() + strs.slice(1);

export const DateFormatter = (date, type) => {
  const newDate = new Date(date);
  switch (type) {
    case 'toString':
      return newDate.toString(); // Fri Jul 02 2021 14:03:54 GMT+0100 (British Summer Time)
    case 'toDateString':
      return newDate.toDateString(); // Fri Jul 02 2021
    case 'toLocaleString':
      return newDate.toLocaleString(); // 7/2/2021, 2:05:07 PM
    case 'toLocaleDateString':
      return newDate.toLocaleDateString(); // 7/2/2021
    case 'toGMTString':
      return newDate.toGMTString(); // Fri, 02 Jul 2021 13:06:02 GMT
    case 'toUTCString':
      return newDate.toUTCString(); // Fri, 02 Jul 2021 13:06:28 GMT
    case 'toISOString':
      return newDate.toISOString(); // 2021-07-02T13:06:53.422Z
    case 'toEventDate':
      return dateFormatter2.format(newDate);
    case 'toEventViewDate':
      return dateFormatter3.format(newDate);
    case 'toTime':
      return dateFormatter4.format(newDate);
    default:
      return newDate;
  }
};

export const formatTime = (time) => {
  if (typeof time !== 'string' || time.trim() === '') {
    return '';
  }
  const [hours, minutes] = time.split(':').map(Number);
  let period = 'AM';

  let adjustedHours = hours;
  if (hours >= 12) {
    period = 'PM';
    adjustedHours = hours > 12 ? hours - 12 : hours;
  }
  if (hours === 0) {
    adjustedHours = 12;
  }

  const formattedTime = `${adjustedHours}:${minutes < 10 ? `0${minutes}` : minutes} ${period}`;
  return formattedTime;
};

/**
 * Short timezone abbreviation for an IANA zone (handles DST). Empty if unknown.
 */
export const getTimezoneAbbr = (ianaTimezone) => {
  if (!ianaTimezone) return '';
  try {
    return moment.tz(ianaTimezone).zoneAbbr() || '';
  } catch {
    return '';
  }
};

/**
 * Formats a date value in the event timezone as MM-DD-YYYY (avoids calendar-day shift vs UTC).
 */
export const formatEventDateTz = (dateValue, ianaTimezone) => {
  if (!dateValue) return '';
  try {
    if (ianaTimezone) {
      const m = moment.tz(dateValue, ianaTimezone);
      if (m.isValid()) return m.format('MM-DD-YYYY');
    }
    const ymd = getEventCalendarDateString(dateValue);
    if (ymd) {
      const [y, mo, d] = ymd.split('-').map(Number);
      return `${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}-${y}`;
    }
    return '';
  } catch {
    return '';
  }
};

const dayOrdinalSuffix = (dayOfMonth) => {
  const n = dayOfMonth;
  const j = n % 10;
  const k = n % 100;
  if (k >= 11 && k <= 13) return 'th';
  if (j === 1) return 'st';
  if (j === 2) return 'nd';
  if (j === 3) return 'rd';
  return 'th';
};

/**
 * Event calendar date in the show timezone, e.g. "08th April 2026" (same TZ rules as formatEventDateTz).
 */
export const formatEventDateOrdinalTz = (dateValue, ianaTimezone) => {
  if (!dateValue) return '';
  try {
    if (ianaTimezone) {
      const m = moment.tz(dateValue, ianaTimezone);
      if (!m.isValid()) return '';
      const d = m.date();
      const dayPadded = String(d).padStart(2, '0');
      return `${dayPadded}${dayOrdinalSuffix(d)} ${m.format('MMMM')} ${m.format('YYYY')}`;
    }
    const ymd = getEventCalendarDateString(dateValue);
    if (ymd) {
      const [y, mo, d] = ymd.split('-').map(Number);
      const m = moment({ year: y, month: mo - 1, date: d });
      if (!m.isValid()) return '';
      const dayPadded = String(d).padStart(2, '0');
      return `${dayPadded}${dayOrdinalSuffix(d)} ${m.format('MMMM')} ${y}`;
    }
    return '';
  } catch {
    return '';
  }
};

/**
 * Formats HH:MM with timezone abbreviation, e.g. "7:00 PM IST".
 */
export const formatEventTime = (timeStr, ianaTimezone) => {
  const formatted = formatTime(timeStr);
  if (!formatted) return '';
  const abbr = getTimezoneAbbr(ianaTimezone);
  return abbr ? `${formatted} ${abbr}` : formatted;
};
